// extracted by mini-css-extract-plugin
export default {"root":"maZWk","preview-icon":"_2_86F","previewIcon":"_2_86F","icon":"_1wwoT","filename":"_3E0U1","extension":"_358FX","file-info":"JruPP","fileInfo":"JruPP","updated":"_1rFTh"};